export default {
  set (state, markets) {
    state.markets = markets
  }
}

